import validationsRegex from '@sword-health/input-validation/dist/scripts/regex'
import { vDefaultValues } from '@sword-health/input-validation/src/scripts/defaults'
import * as z from 'zod'
import { VALIDATION_TYPES } from '@/utils/zod/zod-keys'
import { convertBytes } from '@/utils/convert-bytes'
import '@/utils/zod/zod-extensions'

export const fullNameSchema = () => z.string()
  .min(1)
  .max(vDefaultValues.name.fullname.maxlength)
  .validChars(validationsRegex.name.global)

export const internationalPhoneSchema = () => z.string()
  .validChars(validationsRegex.phone.international)
  .describe({ type: VALIDATION_TYPES.internationalPhoneFormat })
  .min(vDefaultValues.phone.international.minlength + 2)
  .maxLengthMinusOffset(vDefaultValues.phone.international.maxlength, 2) // minLengthMinusOffset offset 2

export const emailSchema = () => z.string()
  .min(1)
  .max(vDefaultValues.email.maxlength)
  .emailFormat()
  
export const passwordSchema = z
  .string()
  .min(vDefaultValues.password.minlength)
  .max(vDefaultValues.password.maxlength)

export const urlSchema = z
  .string()
  .min(1)
  .validUrl()

export const fileMaxSizeSchema = (maxSizeInMB = 50) => z
  .instanceof(File)
  .refine(
    (file) => convertBytes(file.size) <= maxSizeInMB,
  ).describe({ type: VALIDATION_TYPES.maxFileSize, params: { number: maxSizeInMB } })

export const arrayFieldSchema = (maxEntries = 5, maxLengthPerEntry = 255, isRequired = true) => {
  let schema = z.array(z.string().max(maxLengthPerEntry)).max(maxEntries)

  schema = !isRequired ? schema.optional() :
    schema.min(1).refine(
      (arr) => arr.some((s) => s.trim().length > 0),
    ).describe({
      type: VALIDATION_TYPES.required,
    })
  
  return schema
}
